import React from "react";
import { StyleSheet, View } from "react-native";
import { ThemeProvider } from "react-native-elements";

const theme = {
  Button: {
    raised: true,
    titleStyle: {
      color: "#44d9e6",
    },
    buttonStyle: {
      borderRadius: 20,
      height: 50,
      width: 175,
    },
  },
  colors: {
    primary: "#fff",
  },
};

export default class Theme extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <View style={styles.container}>{this.props.children}</View>
      </ThemeProvider>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    flexDirection: "column",
  },
});
